export const talentEditPageStyle = {
  box: {
    marginTop: 200,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'center',
  },
};
